import { quotationBusiness } from "api/bussiness/quotation/quotation-bussiness";
import { GetQuotations } from "api/models/request/quotation/quotation";
import { QuotationPagination } from "api/models/response/pagination";
import {
  createConditionalNaturalLanguageString,
  formatNumber,
} from "commons/ultilities";
import { flow, types } from "mobx-state-tree";
import { withRootStore } from "mobx-stores/_extension/with-root-store";
import {
  IQuotationProperties,
  Quotation,
} from "mobx-stores/_models/quotation/quotation";
import { QuotationItem } from "mobx-stores/_models/quotation/quotation-item";
import { withSetPropAction } from "../_extension/with-set-props";
import { DateRangeFilterStore } from "./common/date-range-filter-store";
import { PaginationStore } from "./common/pagination-store";
export const QuotationQueryParams = types
  .model({
    poDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    deliveryDateRangeFilter: types.optional(DateRangeFilterStore, {}),
    name: "",
    dealingName: "",
    number: "",
    barcode: "",
    code: "",
    dateRangeFilter: types.optional(DateRangeFilterStore, {}),
    isExactMatch: true,
  })
  .actions(withSetPropAction)
  .views((self) => ({
    get natureLanguageString() {
      const map = new Map<
        string,
        { label: string; value: string | number | null | undefined }
      >([
        ["number", { label: "số phiếu", value: self.number }],
        ["dealingName", { label: "tên giao dịch", value: self.dealingName }],
        ["name", { label: "tên hàng", value: self.name }],
        ["barcode", { label: "mã barcode", value: self.barcode }],
        ["code", { label: "mã hàng", value: self.code }],
      ]);

      return createConditionalNaturalLanguageString(map);
    },
  }));
export const QuotationManagement = types
  .model({
    quotations: types.optional(types.array(Quotation), []),
    pagination: types.optional(PaginationStore, {}),
    quotationDetail: types.maybeNull(Quotation),
    selectedQuotationItem: types.maybeNull(QuotationItem),
    openNew: false,
    openEdit: false,
    openDelete: false,
    openPrintPreview: false,
    queryParams: types.optional(QuotationQueryParams, {}),
    searchConditionAsNaturalLanguage: "",
    totalProductCount: 0,
  })
  .extend(withRootStore)
  .actions(withSetPropAction)
  .actions((self) => ({
    createSearchConditionAsNaturalLanguage() {
      const queryParamsAsNaturalLanguage =
        self.queryParams.natureLanguageString;
      return `${
        queryParamsAsNaturalLanguage ? `${queryParamsAsNaturalLanguage} - ` : ""
      }Tổng cộng: ${formatNumber(self.pagination.totalItems)} phiếu - Tổng cộng: ${formatNumber(self.totalProductCount)} mặt hàng`;
    },
  }))
  .actions((self) => ({
    getQuotations: flow(function* getQuotations(request?: GetQuotations) {
      try {
        self._rootStore.setProp("inProgress", true);
        if (!request) {
          request = {
            filter: self.pagination.filter,
            maxResultCount: self.pagination.itemsPerPage,
            skipCount: self.pagination.skipCount,
            sorting: "",
            fromDate:
              self.queryParams.dateRangeFilter.fromAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.from
                ? self.queryParams.dateRangeFilter.from
                : undefined,
            toDate:
              self.queryParams.dateRangeFilter.toAsDayJs?.isValid() &&
              self.queryParams.dateRangeFilter.to
                ? self.queryParams.dateRangeFilter.to
                : undefined,
            dealingName: self.queryParams.dealingName,
            name: self.queryParams.name,
            number: self.queryParams.number,
            barcode: self.queryParams.barcode,
            code: self.queryParams.code,
            isExactMatch: self.queryParams.isExactMatch,
          };
        }
        const res = (yield quotationBusiness.getLists(
          request,
        )) as QuotationPagination<IQuotationProperties>;
        self.setProp(
          "quotations",
          res.items?.map((x, i) => ({
            ...x,
            orderNumber:
              i + 1 + self.pagination.pageIndex * self.pagination.itemsPerPage,
          })),
        );
        self.pagination.setProp("totalItems", res.totalCount);
        self.setProp("totalProductCount", res.totalProductCount || 0);
        self.setProp(
          "searchConditionAsNaturalLanguage",
          self.createSearchConditionAsNaturalLanguage(),
        );
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
    getQuotationDetail: flow(function* getQuotationDetail(id: string) {
      try {
        self._rootStore.setProp("inProgress", true);
        const res = (yield quotationBusiness.getById(
          id,
        )) as IQuotationProperties;
        self.setProp("quotationDetail", res);
      } catch (ex) {
        console.error(ex);
      } finally {
        self._rootStore.setProp("inProgress", false);
      }
    }),
  }));
